import { AppModule } from '@/modules/users/constants/modules';

export const ROUTE_MODULE_MAP: Array<{
  path: string;
  module: AppModule;
}> = [
  { path: '/dashboard', module: 'DASHBOARD' },
  { path: '/services', module: 'SERVICES' },
  { path: '/users', module: 'USERS' },
  { path: '/customers', module: 'CUSTOMERS' },
  { path: '/operations/incidences', module: 'INCIDENCES' },
  { path: '/operations/notices', module: 'NOTIFICATIONS' },
  { path: '/operations/work-orders', module: 'OPERATIONS' },
  { path: '/operations/attendance', module: 'OPERATIONS' },
  { path: '/operations', module: 'OPERATIONS' },
  { path: '/products', module: 'PRODUCTS' },
  { path: '/stock/consolidated', module: 'STOCK' },
  { path: '/stock/serial-numbers', module: 'STOCK' },
  { path: '/stock', module: 'STOCK' },
  { path: '/suppliers', module: 'STOCK' },
  { path: '/purchase-invoices', module: 'STOCK' },
  { path: '/billing', module: 'BILLING' },
  { path: '/accounts-payable', module: 'ACCOUNTING' },
  { path: '/accounting', module: 'ACCOUNTING' },
  { path: '/settings', module: 'SETTINGS' },
];
